import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close as CloseIcon } from "@air/next-icons";
import { VisuallyHidden } from "@air/primitive-visually-hidden";
import * as RadixPopover from "@radix-ui/react-popover";
import classNames from "classnames";
export const PopoverCloseButton = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs(RadixPopover.Close, {
        className: classNames("hover:bg-pigeon-4 flex h-6 w-6 items-center justify-center rounded border-0 bg-transparent text-grey-12 outline-none focus-visible:ring-2 focus-visible:ring-blue-9 active:bg-grey-4", className),
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx(VisuallyHidden, {
                children: "Close popover"
            }),
            /*#__PURE__*/ _jsx(CloseIcon, {
                className: "size-4"
            })
        ]
    });
};
